import Cookie from 'js-cookie';

const videos = document.querySelectorAll('[data-vimeo-id]');

function initVimeo() {
	/**
	 * Create an iframe for embedding a Vimeo video
	 * @param {string} id - Vimeo video ID
	 * @returns {HTMLIFrameElement} - The created iframe element
	 */
	function createIframe(id) {
		try {
			const iframe = document.createElement('iframe');
			iframe.width = 640;
			iframe.height = 360;
			iframe.src = `https://player.vimeo.com/video/${id}?app_id=122963`;
			iframe.frameBorder = 0;
			iframe.allowFullscreen = true;
			iframe.loading = 'lazy'; // Add lazy loading for performance
			iframe.setAttribute('allow', 'autoplay; fullscreen');
			return iframe;
		} catch (error) {
			console.error('Error creating Vimeo iframe:', error);
			return null;
		}
	}

	/**
	 * Initialize the video only if cookies are accepted
	 * @param {string} id - Vimeo video ID
	 * @param {HTMLElement} container - The container for the iframe
	 */
	function initIfCookiesAccepted(id, container) {
		try {
			const basicCookie = Cookie.get('si-cookie-settings-saved-basic');
			const basicSettings = Cookie.get('si-cookie-settings-basic');
			const categoryCookie = Cookie.get('si-cookie-settings-saved-categories');
			const categoryCookieSettings = Cookie.get('si-cookie-settings-categories');

			if (basicCookie === 'true' && basicSettings === 'full') {
				initVideo(id, container);
			} else if (categoryCookie === 'true') {
				const acceptedCookies = JSON.parse(categoryCookieSettings);
				if (acceptedCookies.marketing) {
					initVideo(id, container);
				}
			}
		} catch (error) {
			console.error('Error initializing Vimeo video with cookies:', error);
		}
	}

	/**
	 * Replace the container content with the Vimeo iframe
	 * @param {string} id - Vimeo video ID
	 * @param {HTMLElement} container - The container for the iframe
	 */
	function initVideo(id, container) {
		const iframe = createIframe(id);
		if (iframe) {
			container.innerHTML = '';
			container.classList.add('is-playing');
			container.appendChild(iframe);
		}
	}

	/**
	 * Initialize all videos on the page based on cookie preferences
	 */
	function initAllVideos() {
		videos.forEach((video) => {
			const id = video.dataset.vimeoId;
			const container = video.parentNode;

			initIfCookiesAccepted(id, container);
		});
	}

	initAllVideos();
}

// Initialize Vimeo videos if they are present on the page
if (videos.length) {
	initVimeo();
}

// Listen for the global cookie notice event and re-initialize videos when cookies are updated
document.addEventListener('si_cookie_notice_updated', () => {
	initVimeo();
});
